import React from 'react';
import { Typography, Button, Space } from 'antd';
import { CalculatorOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text, Title, Paragraph } = Typography;

const NAVY = '#0B2545';
const NAVY_MID = '#13315C';
const NAVY_LIGHT = '#1B4175';
const GOLD = '#C5A55A';

const PageHero: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section
      style={{
        background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 50%, ${NAVY_LIGHT} 100%)`,
        padding: '80px 0 64px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative circles */}
      <div
        style={{
          position: 'absolute',
          top: -100,
          right: -70,
          width: 350,
          height: 350,
          borderRadius: '50%',
          background: `rgba(197,165,90,0.06)`,
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: -50,
          left: -35,
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: `rgba(197,165,90,0.04)`,
        }}
      />

      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto' }}>
          <Text
            style={{
              color: GOLD,
              fontSize: 14,
              fontWeight: 600,
              letterSpacing: 2,
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: 16,
            }}
          >
            AI-Powered Precision Medicine
          </Text>
          <Title
            style={{
              color: '#fff',
              fontSize: 42,
              lineHeight: 1.3,
              margin: '0 0 20px',
              fontWeight: 700,
            }}
          >
            精准给药，AI 驱动个体化治疗
          </Title>
          <Paragraph
            style={{
              color: 'rgba(255,255,255,0.75)',
              fontSize: 17,
              lineHeight: 1.7,
              maxWidth: 600,
              margin: '0 auto 28px',
            }}
          >
            基于群体药动学模型与贝叶斯估算，为每位患者量身定制最优给药方案
          </Paragraph>
          <Space size={16}>
            <Button
              type="primary"
              size="large"
              icon={<ArrowRightOutlined />}
              onClick={() => navigate('/register')}
              style={{
                background: GOLD,
                borderColor: GOLD,
                color: NAVY,
                fontWeight: 600,
                height: 46,
                padding: '0 30px',
                fontSize: 15,
              }}
            >
              开始使用
            </Button>
            <Button
              size="large"
              ghost
              onClick={() => navigate('/#how-it-works')}
              style={{
                borderColor: 'rgba(255,255,255,0.4)',
                color: '#fff',
                height: 46,
                padding: '0 26px',
              }}
            >
              了解更多
            </Button>
          </Space>
          <div style={{ marginTop: 32 }}>
            <CalculatorOutlined
              style={{
                fontSize: 56,
                color: 'rgba(197,165,90,0.25)',
              }}
            />
            <div
              style={{
                marginTop: 10,
                color: 'rgba(255,255,255,0.4)',
                fontSize: 13,
              }}
            >
              MIPD · PopPK · Bayesian Estimation
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
